(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerListName', {
    bindings: {
      campaign: '<',
      isAffiliate: '<',
      showOfferSummary: '&'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/offer-list-name/offer-list-name.view.html'
  });

})();
